import { useFetcher } from "react-router"
import type { ActionResponse } from "@/utils/types"
import type { LoaderData } from "./brand-ui-config"
import { SharedRetentionTab, type RetentionConfig } from "../shared/SharedRetentionTab"

export function RetentionTabUiConfig({ config, data }: { config: RetentionConfig | undefined; data: LoaderData }) {
  const fetcher = useFetcher<ActionResponse>()

  const pendingAction = (fetcher.formData?.get("action") as "SAVE_SECTION" | "REMOVE_SECTION" | null) ?? null

  const handleSave = (newConfig: RetentionConfig) => {
    const formData = new FormData()
    formData.append("action", "SAVE_SECTION")
    formData.append("organisation", data.loadedOrganisation)
    formData.append("brand", data.loadedBrand ?? "")
    formData.append("jsonPath", "$.retention")
    formData.append("value", JSON.stringify(newConfig))
    formData.append("concurrency", data.config?.concurrency ?? "")

    fetcher.submit(formData, { method: "post" })
  }

  const handleRemove = () => {
    const formData = new FormData()
    formData.append("action", "REMOVE_SECTION")
    formData.append("organisation", data.loadedOrganisation)
    formData.append("brand", data.loadedBrand ?? "")
    formData.append("jsonPath", "$.retention")
    formData.append("concurrency", data.config?.concurrency ?? "")

    fetcher.submit(formData, { method: "post" })
  }

  return (
    <SharedRetentionTab
      config={config ?? {}}
      onSave={handleSave}
      onRemove={handleRemove}
      isFetching={fetcher.state !== "idle"}
      currentAction={pendingAction}
      fetcherData={fetcher.data}
    />
  )
}
